import React, { createContext, useContext, useState } from 'react';

const SoundContext = createContext();

export const useSoundContext = () => {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSoundContext must be used within a SoundProvider');
  }
  return context;
};

export const SoundProvider = ({ children }) => {
  const [isSoundEnabled, setIsSoundEnabled] = useState(false);

  const toggleSound = () => {
    setIsSoundEnabled(!isSoundEnabled);
  };

  return (
    <SoundContext.Provider value={{ 
      isSoundEnabled, 
      setIsSoundEnabled, 
      toggleSound 
    }}>
      {children}
    </SoundContext.Provider>
  );
};

export default SoundContext; 
